module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--messaging main--full-height"
  }, [_c('div', {
    staticClass: "appointments messaging group--wide messaging--messagessidebar"
  }, [_c('div', {
    staticClass: "conversation-list"
  }, [_c('h2', {
    staticClass: "h2 list-provider__title",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Your Messages")]), _vm._v(" "), _c('div', {
    staticClass: "conversations"
  }, _vm._l((_vm.providerList), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "current-conversation"
    }, [_c('div', {
      class: [_vm.selectedId && item.id === _vm.selectedId ? 'conversation-preview active' : 'conversation-preview', item.unread_messages ? 'conversation-unread' : 'conversation-read'],
      style: (_vm.getActivecssstyle(item.id, _vm.org)),
      on: {
        "click": function($event) {
          return _vm.handleClick(item, item.id, item.provider.fullname)
        }
      }
    }, [_c('div', {
      staticClass: "conversation-preview-thumb-wrapper"
    }, [_c('span', [_vm._v(_vm._s(_vm.displayName(item.provider.fullname)))])]), _vm._v(" "), _c('div', {
      staticClass: "conversation-preview-body"
    }, [_c('p', {
      staticClass: "conversation-preview-body-title"
    }, [_c('span', [_vm._v(_vm._s(item.provider.fullname))]), _vm._v(" "), _c('span', {
      staticClass: "c-specialty conversation-preview-time"
    }, [_vm._v(_vm._s(_vm.formatTime(item.last_message_at)))])]), _vm._v(" "), _c('p', {
      staticClass: "conversation-preview-body-subject"
    }, [_vm._v(" " + _vm._s(item.recent_message_subject))]), _vm._v(" "), _c('p', {
      staticClass: "conversation-preview-body-text"
    }, [_vm._v(" " + _vm._s(item.recent_message_body))])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "appointments__content chat"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "defaultmessage",
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px"
    }
  }, [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedItem), function(item) {
    return _c('div', {
      key: item.id
    }, [(item.id) ? _c('div', {
      staticClass: "table__column conversation"
    }, [_c('div', {
      staticClass: "conversation-right-header"
    }, [_c('p', {
      staticClass: "h2 list-provider__title",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(item.provider.provider_card.full_name_with_affixes))]), _vm._v(" "), _c('p', {
      staticClass: "conversation-preview-body-subject c-black"
    }, [_vm._v(" " + _vm._s(item.recent_message_subject))])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.selectedId) ? _c('div', {
    staticClass: "default-window"
  }, [_c('div', {
    staticClass: "chat-window"
  }, [_c('div', {
    staticClass: "right-left"
  }, _vm._l((_vm.apiResponse), function(message) {
    return _c('div', {
      key: message.id
    }, [_c('div', {
      class: {
        'chat-right-wind float-right': message.isUser, 'chat-right-wind': message.from
      }
    }, [_c('div', {
      staticClass: "chatmsg c-mid fw-bold"
    }, [_vm._v(_vm._s(message.isUser ? _vm.localUserdata : message.from) + "\n                  "), _c('span', {
      staticClass: "chatmsgtime c-mid"
    }, [_vm._v(_vm._s(_vm.formatTime(message.isUser ? message.date_time : message.date_time)))])]), _vm._v(" "), _c('div', {
      class: {
        'user-message': message.from, 'bot-message': message.isUser
      },
      style: (_vm.getCssstyle(message.isUser, _vm.org))
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(message.message)
      }
    })])])])
  }), 0)]), _vm._v(" "), (_vm.reply(_vm.apiResponse)) ? _c('div', {
    staticClass: "input-area"
  }, [_c('div', {
    staticClass: "large-12 medium-12 small-12 cell"
  }, [_c('label', {
    staticClass: "attachment",
    style: ({
      'background-color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "for": "select-files"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.attachment_icon,
      "alt": "Attachment_icon"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "select-files",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFilesUpload($event)
      },
      "click": function($event) {
        !_vm.isFile ? _vm.handleFileOnClick($event) : _vm.sendMessage()
      }
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputmessage),
      expression: "inputmessage"
    }],
    ref: "messageInput",
    staticClass: "con-input",
    attrs: {
      "placeholder": "Type your message..."
    },
    domProps: {
      "value": (_vm.inputmessage)
    },
    on: {
      "keydown": _vm.handleKeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputmessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "conver-btn",
    style: ({
      'background-color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "disabled": !_vm.inputmessage && !_vm.isFile
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("Reply")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "deleteicon"
  }, _vm._l((_vm.files), function(file, key) {
    return _c('div', {
      key: 'file-' + key,
      staticClass: "file-listing"
    }, [_c('span', {
      staticClass: "filename"
    }, [_vm._v(_vm._s(file.name) + " ")]), _c('span', {
      staticClass: "remove-file",
      on: {
        "click": function($event) {
          return _vm.removeFile()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.delete_icon,
        "alt": "Delete_icon"
      }
    })])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.providerList.length <= 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "defaultmessage"
  }, [_vm._v("You have not received a message from any counselors yet.")]) : _vm._e(), _vm._v(" "), (_vm.errorMsg) ? _c('p', {
    staticClass: "errormsg"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _vm._v(" "), (!_vm.selectedId && _vm.providerList.length > 0) ? _c('p', {
    staticClass: "centered-message"
  }, [_vm._v("No Conversation Selected")]) : _vm._e(), _vm._v(" "), (!_vm.selectedId && _vm.providerList.length > 0) ? _c('p', {
    staticClass: "fine-message"
  }, [_vm._v("Select a conversation to read.")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-383700d5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/conversations/Conversation.vue
// module id = 531
// module chunks = 0